import { useCallback, useEffect, useState } from "react";
import { CourseForOverview } from "../../types";
import { getCourseOverView } from "../../api";

const useCourseOverview = (courseNo?: string) => {
  const [overview, setOverview] = useState<CourseForOverview>();
  const getData = useCallback(() => {
    if (!courseNo) {
      return;
    }
    getCourseOverView(courseNo).then(setOverview);
  }, [courseNo]);
  const refresh = () => {
    getData();
  };

  useEffect(() => {
    getData();
  }, [courseNo, getData]);

  return { overview, refresh };
};

export default useCourseOverview;
